import { useEffect } from "react"
import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerBlogDigest = props => {

  const blogDigestFeaturedClicks = event => {
    if (
      (containsValidTargetClass(
        ["t2-blog-digest__featured-posts__item"],
        event?.target?.classList
      ) || event?.target?.parentNode?.classList.contains("t2-blog-digest__latest-article"))
    ) {
      const datalayerObj = {    
        event: 'text_link_click',    
        // 'click_label': 'Read now', //link text label    - N/A - not available in this component
        click_url: event?.target?.href,     
        click_within_card: containsValidTargetClass(
          ["t2-blog-digest__featured-posts__item"], event?.target?.classList) ? true : false, //if link is contained within card, true|false    
        current_page: window?.location?.pathname,     
        content_heading: event?.target?.querySelector('.t2-blog-digest__featured-posts__card-header, .t2-blog-digest__latest-article__title')?.innerText,    
        // 'content_subheading': '<content subheading>',  N/A - not available in this component  
        content_eyebrow: event?.target?.querySelector('.t2-blog-digest__latest-article__eyebrow')?.innerText || null,   // N/A on side featured posts, but available on promoted main post
        content_section: event?.target?.querySelector('.t2-blog-digest__latest-article__excerpt, .t2-blog-digest__featured-posts__card-desc')?.innerText, 
        // 'content_category': '<content category>',    N/A - not available in this component
        // 'content_author': '<content author>'   N/A - not available in this component
      }
      window.dataLayer.push(datalayerObj);
    }
  }

  // add handler if relevant listener elem exists
  let featuredPostClickQuery = "",
  searchQuery = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    featuredPostClickQuery = document?.querySelectorAll(".t2-blog-digest__featured-posts__item").length > 0
  }
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    searchQuery = document?.querySelectorAll(".t2-search-button").length > 0
  }
  useClickListener(blogDigestFeaturedClicks, featuredPostClickQuery)

}

export default DatalayerBlogDigest
